<template>
  <div class="wrapper">
    <div v-for="tab in tabDefinitions" :key="tab.id">
      <div v-if="value === tab.id" class="selected-tab">
        {{ tab.name }}
      </div>
      <ts-button v-else class="tab-button" @click="handleTabClick(tab)">{{ tab.name }}</ts-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  width: 192px;
  flex-shrink: 0;
}

.selected-tab {
  padding: 18px 24px;
  padding-right: 42px;
  margin-bottom: 20px;
  border-top-left-radius: 32px;
  border-bottom-left-radius: 32px;
  background-color: #e7e8ed;

  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  color: #6d7587;
  text-align: center;
}

.tab-button {
  margin-bottom: 20px;
  padding-right: 18px;
  width: 100%;
}
</style>

<script>
export default {
  props: {
    tabDefinitions: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit('input', tab.id);
    }
  }
};
</script>
